import CryptoJS from "crypto-js";

export const hashEmail = (email: string): string =>
  CryptoJS.SHA256(email.trim().toLowerCase()).toString(CryptoJS.enc.Hex);
